import {
  Box,
  Button,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import React, { useState } from 'react';

import CessionModule from './components/CessionModule';
import CessionModuleSII from './components/CessionModuleSII';

interface CessionMainProps {
  selectedRequest: any;
  setOpenShoppingCart: (open: boolean) => void;
  setSuccessOpen?: (message: string) => void;
  setFailureOpen?: (message: string) => void;
}

const CessionMain: React.FC<CessionMainProps> = ({
  selectedRequest,
  setOpenShoppingCart,
  setSuccessOpen,
  setFailureOpen,
}) => {
  const [cessionType, setCessionType] = useState<'facturador' | 'sii'>(
    'facturador',
  );
  const [showModule, setShowModule] = useState(false);

  const handleCessionTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCessionType(event.target.value as 'facturador' | 'sii');
  };

  const handleContinue = () => {
    setShowModule(true);
  };

  const handleBack = () => {
    setShowModule(false);
  };

  if (showModule) {
    return (
      <div>
        {cessionType === 'facturador' ? (
          <CessionModule
            selectedRequest={selectedRequest}
            setOpenShoppingCart={setOpenShoppingCart}
          />
        ) : (
          <CessionModuleSII
            selectedRequest={selectedRequest}
            setOpenShoppingCart={setOpenShoppingCart}
            setSuccessOpen={setSuccessOpen}
            setFailureOpen={setFailureOpen}
          />
        )}
      </div>
    );
  }

  return (
    <div>
      <FormControl component="fieldset" style={{ marginBottom: 20 }}>
        <FormLabel component="legend">Seleccione el tipo de cesión</FormLabel>
        <RadioGroup
          aria-label="tipo-cesion"
          name="tipo-cesion"
          value={cessionType}
          onChange={handleCessionTypeChange}
          row
        >
          <FormControlLabel
            value="facturador"
            control={<Radio />}
            label="Tengo facturador de mercado"
          />
          <FormControlLabel
            value="sii"
            control={<Radio />}
            label="Tengo facturador gratuito del SII"
          />
        </RadioGroup>
      </FormControl>
      <DialogActions>
        <CustomButton
          onClick={handleContinue}
          color="primary"
          variant="contained"
        >
          Continuar
        </CustomButton>
      </DialogActions>
    </div>
  );
};

export default CessionMain;
